export default class ProgressBar extends HTMLElement {
  private step = 0;
  private leftlabel = '';
  private middlelabel = '';
  private rightlabel = '';

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return ['step', 'leftlabel', 'middlelabel', 'rightlabel'];
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'step') {
      this.step = parseInt(newValue);
    } else if (name === 'leftlabel') {
      this.leftlabel = newValue;
    } else if (name === 'rightlabel') {
      this.rightlabel = newValue;
    } else if (name === 'middlelabel') {
      this.middlelabel = newValue;
    }
  }

  private render() {
    this.shadowRoot!.innerHTML = `
  <style>
    svg {
        width: 100%;
        height: auto;
        display: block;
    }
    .label { font: 600 0.6rem "Montserrat"; fill: #000; text-anchor: middle; }
  </style>
    <svg viewBox="-8 0 354 68" fill="none" xmlns="http://www.w3.org/2000/svg">

      <!-- LEFT STEP -->
      <circle cx="25" cy="25" r="21" fill="black"/>
      ${
        this.step > 0
          ? '<path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" transform="translate(25 25) translate(-12 -12)"/>'
          : '<path d="M23 15V17M27 15V17M29 21C29.2652 21 29.5196 21.1054 29.7071 21.2929C29.8946 21.4804 30 21.7348 30 22V30C30 31.0609 29.5786 32.0783 28.8284 32.8284C28.0783 33.5786 27.0609 34 26 34H20C18.9391 34 17.9217 33.5786 17.1716 32.8284C16.4214 32.0783 16 31.0609 16 30V22C16 21.7348 16.1054 21.4804 16.2929 21.2929C16.4804 21.1054 16.7348 21 17 21H31C32.0609 21 33.0783 21.4214 33.8284 22.1716C34.5786 22.9217 35 23.9391 35 25C35 26.0609 34.5786 27.0783 33.8284 27.8284C33.0783 28.5786 32.0609 29 31 29H30M19 15V17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      }

      <!-- CENTER STEP -->
      <circle cx="173" cy="25" r="21" fill="${this.step === 0 ? '#D5D5D5' : 'black'}"/>
      ${
        this.step > 1
          ? '<path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" transform="translate(173 25) translate(-12 -12)"/>'
          : '<path d="M163 23H183M165 18H181C182.105 18 183 18.8954 183 20V30C183 31.1046 182.105 32 181 32H165C163.895 32 163 31.1046 163 30V20C163 18.8954 163.895 18 165 18Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      }

      <!-- RIGHT STEP -->
      <circle cx="321" cy="25" r="21" fill="${this.step === 0 ? '#D5D5D5' : 'black'}"/>
      <path d="M318.913 26.0853C318.722 25.8945 318.494 25.7444 318.244 25.6441L310.314 22.4641C310.219 22.4261 310.138 22.36 310.082 22.2748C310.026 22.1895 309.998 22.0892 310 21.9872C310.003 21.8852 310.037 21.7865 310.097 21.7042C310.157 21.622 310.241 21.5602 310.338 21.5271L329.338 15.0271C329.426 14.9951 329.522 14.9889 329.614 15.0094C329.706 15.03 329.79 15.0762 329.857 15.1428C329.924 15.2094 329.97 15.2937 329.99 15.3856C330.011 15.4776 330.005 15.5734 329.973 15.6621L323.473 34.6621C323.44 34.7586 323.378 34.8426 323.296 34.903C323.213 34.9633 323.115 34.9971 323.013 34.9997C322.911 35.0023 322.81 34.9737 322.725 34.9176C322.64 34.8615 322.574 34.7807 322.536 34.6861L319.356 26.7541C319.255 26.5036 319.104 26.2761 318.913 26.0853ZM318.913 26.0853L329.854 15.1471" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>

      <!-- CONNECTORS -->
      <line x1="49" y1="25.5" x2="149" y2="25.5" stroke="${this.step === 0 ? '#D5D5D5' : 'black'}" stroke-width="3"/>
      <line x1="197" y1="25.5" x2="297" y2="25.5" stroke="${this.step === 0 ? '#D5D5D5' : 'black'}" stroke-width="3"/>

      <!-- ACTIVE STEP -->
      <circle cx="${this.step === 0 ? 25 : 321}" cy="25" r="24" stroke="black" stroke-width="2" stroke-dasharray="4 4"/>

      <!-- REAL TEXT NODES (edit these) -->
      <text class="label" x="25"  y="65">${this.leftlabel}</text>
      <text class="label" x="173" y="65">${this.middlelabel}</text>
      <text class="label" x="321" y="65">${this.rightlabel}</text>
    </svg>
    `;
  }

  connectedCallback() {
    this.render();
  }
}

customElements.define('progress-bar', ProgressBar);
